export default "__VITE_ASSET__mj5izPnB__"